import type { ButtonProps } from "@mui/material";
import { Button } from "@mui/material";
import { useContext } from "react";

import { FeedContext } from "@/models/FeedContextProvider";
import { TrackingContext } from "@/models/TrackingStateProvider";
import FileUploadModal from "./FileUploadModal";

export type UploadFileButtonProps = ButtonProps & {
  button?: React.ReactNode;
};

export default function UploadFileButton({ children, button, ...props }: UploadFileButtonProps) {
  const { ampli } = useContext(TrackingContext);
  const { setFileUploadModal } = useContext(FeedContext);

  const toggleFileUpload = () => {
    ampli.fileUploadInvoke();
    setFileUploadModal((value) => !value);
  };

  return (
    <>
      <FileUploadModal />
      {button ? (
        <span onClick={toggleFileUpload} aria-label="Upload File" {...props}>
          {button}
        </span>
      ) : (
        <Button onClick={toggleFileUpload} aria-label="Upload File" {...props}>
          {children}
        </Button>
      )}
    </>
  );
}
